import { FC } from 'react';
import CallButton from '@acorn-portal/shared/src/components/buttons/CallButton';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { getPhoneNumber } from '@acorn-portal/shared/src/utils/get-phone-numbers';
import { AddOn } from '@acorn-portal/shared/src/services/api';

interface AddOnPhoneNumbersProps {
	addOns?: AddOn[];
	product: Product;
}

/**
 * Component to render phone numbers for add-ons (Breakdown, Keycare, etc.)
 */
const AddOnPhoneNumbers: FC<AddOnPhoneNumbersProps> = ({ addOns, product }) => {
	if (!addOns) {
		return null;
	}

	const hasBreakdown = addOns.find((e) => e.name?.includes('Breakdown'));
	const hasKeycare = addOns.find((e) => e.name?.includes('Keycare'));

	return (
		<>
			{hasBreakdown && (
				<CallButton
					buttonLabel={`Breakdown: ${getPhoneNumber(product, 'BD')}`}
					phoneNumber={`${getPhoneNumber(product, 'BD')}`}
				/>
			)}
			{hasKeycare && (
				<CallButton
					buttonLabel={`Keycare: ${getPhoneNumber(product, 'KEYCARE')}`}
					phoneNumber={`${getPhoneNumber(product, 'KEYCARE')}`}
				/>
			)}
		</>
	);
};

export default AddOnPhoneNumbers;
